import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import SVG from '../SVG/SVG'
import { isClientSide } from '../Common/utils'
import obj2Arr from '../../../utils/obj2Arr'
import { setCookie, getCookie } from '../../../utils/cookies'
import AlertBar from './AlertBar'
import useStyles from './header.styles'
import { debounce } from 'lodash'

const Header = props => {
  const { rightLinks, menuLinks, WebSettings, alertBars } = props
  const classes = useStyles()
  const [displayDiscountBtn, setDisplayDiscountBtn] = useState(false)
  const [alertBarActive, setAlertBarActive] = useState(false)
  const [active, setActiveState] = useState(false)
  const [subMenuActive, setSubMenuActive] = useState(false)
  const [subMenu, setSubMenu] = useState('')
  const [isMobile, setIsMobile] = useState(false)
  const [contentMargin, setContentMargin] = useState(94)
  const [loggedIn, setLoggedIn] = useState(false)

  const enableSubNav = arr => {
    try {
      if (arr.length > 0) {
        const emre = arr.map(item => item.filter(link => link.hidden == '0'))
        return emre.flat(1).length > 0
      }
      return false
    } catch (error) {
      return false
    }
  }

  function toggleMenu() {
    const newState = !active
    if (isClientSide) {
      document.querySelector('body').style.overflow = newState ? 'hidden' : 'auto'
      document.querySelector('body').style.height = newState ? '100vh' : 'auto'
    }
    setActiveState(newState)
  }

  const mobileClasses = active
    ? `${classes.mobileNav} ${classes.mobileNavActive}`
    : classes.mobileNav

  useEffect(() => {
    const currentPath = window.location.pathname
    const emreLinks = [...menuLinks, ...rightLinks]

    emreLinks.map(link => {
      if (link.href === currentPath && link.items.length > 0) setSubMenuActive(true)
      try {
        if (link.items.length > 0) {
          link.items.map(linkx => {
            if (linkx.href === currentPath) setSubMenuActive(true)
          })
        }
      } catch (error) {}
      setSubMenu(currentPath)
    })

    if (window.innerWidth < 1280) {
      setIsMobile(true)
    }
  }, [menuLinks, rightLinks])

  useEffect(() => {
    if (getCookie('loggedIn') === 'true') {
      setLoggedIn(true)
    }
    if (getCookie('loggedIn') === 'true') {
      setLoggedIn(true)
    }
    if (getCookie('velocityPromo') === null) {
      setDisplayDiscountBtn(true)
    } else {
      setDisplayDiscountBtn(false)
    }
    setTimeout(() => {
      if (getCookie('velocityPromo') === null) {
        setDisplayDiscountBtn(true)
      } else {
        setDisplayDiscountBtn(false)
      }
    }, 2000)
    setTimeout(() => {
      if (getCookie('velocityPromo') === null) {
        setDisplayDiscountBtn(true)
      } else {
        setDisplayDiscountBtn(false)
      }
    }, 4000)
  }, [])

  const updateContentMargin = header => {
    setContentMargin(header.getBoundingClientRect().height)
  }

  useEffect(() => {
    const header = document.querySelector('header')
    updateContentMargin(header)

    const handleResize = _.debounce(() => {
      updateContentMargin(header)
    }, 50)

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  useEffect(() => {
    const header = document.querySelector('header')
    updateContentMargin(header)
  }, [alertBarActive])

  const openFormPanel = () => {
    let formPanel = document.getElementById('form-panel')
    if (!formPanel) return

    formPanel.classList.add('is-active')
    document.body.style.overflow = 'hidden'
  }

  return (
    <>
      <div className={classes.spacer} style={{ height: contentMargin }}></div>
      <header className={classes.header}>
        <AlertBar
          alertBars={alertBars}
          WebSettings={WebSettings}
          isActive={alertBarActive}
          setState={state => setAlertBarActive(state)}
        />

        <div className={classes.headerMain}>
          <div style={{ display: 'flex', width: '100%' }}>
            <div style={{ height: 8, backgroundColor: '#AB206C', width: '12.5%' }}></div>
            <div style={{ height: 8, backgroundColor: '#EE2049', width: '12.5%' }}></div>
            <div style={{ height: 8, backgroundColor: '#F36C3D', width: '12.5%' }}></div>
            <div style={{ height: 8, backgroundColor: '#F8DD61', width: '12.5%' }}></div>
            <div style={{ height: 8, backgroundColor: '#007AC3', width: '50%' }}></div>
          </div>
          <div className={classes.headerMainInner}>
            <div className={classes.headerLogo}>
              <a href="/" className={classes.sitelogo}>
                <img src="/themes/thrifty/assets/images/logo.png" alt="Thrifty" />
              </a>
              <nav className={classes.headerNav}>
                <ul className={classes.headerNavItems}>
                  {menuLinks
                    .filter(menuLink => menuLink.hidden == '0')
                    .map((link, index) => {
                      const isSubMenu =
                        link.href === subMenu || link.items.find(item => item.href === subMenu)
                      return (
                        <li
                          className={`${classes.headerNavItem} ${isSubMenu ? 'is-active' : null}`}
                          key={`header-menu-link-${index}`}
                        >
                          <a
                            href={link.href}
                            className={`${classes.headerNavLink} ${isSubMenu ? 'is-active' : null}`}
                            target={link.external == '1' ? '_blank' : ''}
                            rel="noreferrer"
                          >
                            {link.text}
                          </a>
                          {link.itemsOpt &&
                            obj2Arr(link.itemsOpt).length > 0 &&
                            enableSubNav(obj2Arr(link.itemsOpt)) && (
                              <div className="hoverMenu" style={{ top: contentMargin }}>
                                <div className="hoverMenuLinks">
                                  {obj2Arr(link.itemsOpt).map((itemLinks, itemIndexOpt) => (
                                    <ul key={`header-menu-item-link-${itemIndexOpt}`}>
                                      {itemLinks
                                        .filter(link => link.hidden == '0')
                                        .map((itemLink, itemIndex) => (
                                          <li key={`header-menu-item-link-${itemIndex}`}>
                                            {itemLink.href && (
                                              <a
                                                className={
                                                  subMenu === itemLink.href
                                                    ? 'activeMenuLink'
                                                    : null
                                                }
                                                href={itemLink.href}
                                                target={itemLink.external == '1' ? '_blank' : ''}
                                                rel="noreferrer"
                                              >
                                                {itemLink.text}
                                              </a>
                                            )}
                                          </li>
                                        ))}
                                    </ul>
                                  ))}
                                </div>
                              </div>
                            )}
                        </li>
                      )
                    })}
                </ul>
              </nav>
            </div>
            {!loggedIn ? (
              <div className={classes.headerNavWrapper}>
                <ul className={classes.headerNavItems}>
                  {rightLinks
                    .filter(rightLink => rightLink.hidden == '0')
                    .map((link, index) => {
                      const isSubMenu =
                        link.href === subMenu || link.items.find(item => item.href === subMenu)
                      return (
                        <li
                          className={`${classes.headerNavItem} ${isSubMenu ? 'is-active' : null}`}
                          key={`header-menu-link-${index}`}
                        >
                          <a
                            href={link.href}
                            className={`${classes.headerNavLink} ${isSubMenu ? 'is-active' : null}`}
                            target={link.external == '1' ? '_blank' : ''}
                            rel="noreferrer"
                          >
                            {link.text}
                          </a>
                          {link.itemsOpt &&
                            obj2Arr(link.itemsOpt).length > 0 &&
                            enableSubNav(obj2Arr(link.itemsOpt)) && (
                              <div className="hoverMenu" style={{ top: contentMargin }}>
                                <div
                                  className="hoverMenuLinks"
                                  style={{
                                    paddingRight: '35px',
                                    justifyContent: 'end',
                                  }}
                                >
                                  {obj2Arr(link.itemsOpt).map((itemLinks, itemIndexOpt) => (
                                    <ul key={`header-menu-item-link-${itemIndexOpt}`}>
                                      {itemLinks
                                        .filter(link => link.hidden == '0')
                                        .map((itemLink, itemIndex) => (
                                          <li key={`header-menu-item-link-${itemIndex}`}>
                                            {itemLink.href && (
                                              <a
                                                className={
                                                  subMenu === itemLink.href
                                                    ? 'activeMenuLink'
                                                    : null
                                                }
                                                href={itemLink.href}
                                                target={itemLink.external == '1' ? '_blank' : ''}
                                                rel="noreferrer"
                                              >
                                                {itemLink.text}
                                              </a>
                                            )}
                                          </li>
                                        ))}
                                    </ul>
                                  ))}
                                </div>
                              </div>
                            )}
                        </li>
                      )
                    })}

                  {WebSettings.headerButtonText && displayDiscountBtn && (
                    <li className={classes.headerNavItemRight}>
                      <a
                        href={WebSettings.headerButtonURL}
                        className={classes.headerNavLinkBooking}
                        style={{ cursor: 'pointer' }}
                      >
                        {WebSettings.headerButtonText}
                      </a>
                    </li>
                  )}
                  {/* {WebSettings.headerButtonText && displayDiscountBtn && (
                    <div
                      onClick={openFormPanel}
                      className={classes.headerNavLinkBooking}
                      style={{ cursor: 'pointer' }}
                    >
                      {WebSettings.headerButtonText}
                    </div>
                  )} */}
                </ul>
              </div>
            ) : (
              <div style={{ display: 'flex' }}>
                <img
                  src="/themes/thrifty/assets/images/profile.png"
                  alt="profile"
                  style={{ marginRight: '20px' }}
                />
                <div
                  onClick={() => {
                    setCookie('loggedIn', 'false', 4380)
                    setLoggedIn(false)
                    setCookie('iataCode', '', 4380)
                    window.location = '/travelagent'
                  }}
                  style={{ display: 'flex', alignItems: 'center' }}
                >
                  <img
                    src="/themes/thrifty/assets/images/exit.png"
                    alt="exit"
                    style={{ cursor: 'pointer' }}
                  />
                  <span style={{ paddingLeft: '5px', cursor: 'pointer', color: '#000' }}>
                    Logout
                  </span>
                </div>
              </div>
            )}
            <div className={mobileClasses} style={{ top: contentMargin }}>
              <div className={classes.mobileNavInner} style={{ gridArea: 'left' }}>
                <nav>
                  <ul className={classes.mobileNavItems}>
                    {menuLinks.map((link, index) => (
                      <li
                        key={`header-menu-mobile-link-${index}`}
                        className={classes.mobileNavItems}
                      >
                        <a
                          href="#"
                          onClick={e => {
                            e.preventDefault()
                            if (link.itemsOpt && obj2Arr(link.itemsOpt).length > 0) {
                              if (
                                document
                                  .querySelector(`#submenu${index}`)
                                  .classList.contains('is-closed')
                              ) {
                                document
                                  .querySelector(`#toggle-btn-${index}`)
                                  .classList.add('is-active')
                                document
                                  .querySelector(`#submenu${index}`)
                                  .classList.remove('is-closed')
                              } else {
                                document
                                  .querySelector(`#toggle-btn-${index}`)
                                  .classList.remove('is-active')
                                document
                                  .querySelector(`#submenu${index}`)
                                  .classList.add('is-closed')
                              }
                            } else {
                              top.location = link.href
                            }
                          }}
                          className={`${classes.mobileHeaderNavLink} ${
                            link.class ? link.class : ''
                          }`}
                        >
                          {link.text}

                          {link.itemsOpt &&
                            obj2Arr(link.itemsOpt).length > 0 &&
                            enableSubNav(obj2Arr(link.itemsOpt)) && (
                              <span className={`${classes.toggleBtn}`} id={`toggle-btn-${index}`}>
                                <SVG name="Chevron" width={10} height={10} />
                              </span>
                            )}
                        </a>
                        {link.itemsOpt &&
                          obj2Arr(link.itemsOpt).length > 0 &&
                          enableSubNav(obj2Arr(link.itemsOpt)) && (
                            <div className={`is-closed`} id={`submenu${index}`}>
                              <>
                                {obj2Arr(link.itemsOpt).map((itemLinks, itemIndexOpt) => (
                                  <ul
                                    key={`subheader-menu-item-link-${itemIndexOpt}`}
                                    style={{ padding: 0, margin: 0, listStyle: 'none' }}
                                  >
                                    {itemLinks
                                      .filter(link => link.hidden == '0')
                                      .map((itemLink, itemIndex) => (
                                        <li
                                          key={`header-menu-item-link-${itemIndex}`}
                                          className={itemLink.href && `linksubmenu${itemIndexOpt}`}
                                        >
                                          {itemLink.href && (
                                            <a
                                              href={itemLink.href}
                                              style={{
                                                fontFamily: 'TTRounds',
                                                fontStyle: 'normal',
                                                fontWeight: 'bold',
                                                fontSize: '15px',
                                                lineHeight: '17px',
                                                textDecoration: 'none',
                                                padding: '12px 0',
                                                display: 'block',
                                                color: '#2D2D2D',
                                              }}
                                            >
                                              {itemLink.text}
                                            </a>
                                          )}
                                          {!itemLink.href && (
                                            <span
                                              style={{
                                                fontFamily: 'TTRounds',
                                                fontStyle: 'normal',
                                                fontWeight: 'bold',
                                                fontSize: '18px',
                                                lineHeight: '22px',
                                                display: 'block',
                                                padding: '12px 0 7px',
                                              }}
                                            >
                                              <a
                                                href="#"
                                                onClick={e => {
                                                  e.preventDefault()
                                                  if (
                                                    document
                                                      .querySelector(`#toggle-btn2-${itemIndexOpt}`)
                                                      .classList.contains('is-active')
                                                  ) {
                                                    document
                                                      .querySelector(`#toggle-btn2-${itemIndexOpt}`)
                                                      .classList.remove('is-active')
                                                    document
                                                      .querySelectorAll(
                                                        `.linksubmenu${itemIndexOpt}`,
                                                      )
                                                      .forEach(function(el) {
                                                        el.classList.add('is-closed')
                                                      })
                                                  } else {
                                                    document
                                                      .querySelector(`#toggle-btn2-${itemIndexOpt}`)
                                                      .classList.add('is-active')
                                                    document
                                                      .querySelectorAll(
                                                        `.linksubmenu${itemIndexOpt}`,
                                                      )
                                                      .forEach(function(el) {
                                                        el.classList.remove('is-closed')
                                                      })
                                                  }
                                                }}
                                                style={{
                                                  color: '#007AC3',
                                                  textDecoration: 'none',
                                                }}
                                              >
                                                {itemLink.text}
                                                {itemLinks.length > 1 && (
                                                  <span
                                                    id={`toggle-btn2-${itemIndexOpt}`}
                                                    className={classes.toggleBtn}
                                                    style={{ marginLeft: 30 }}
                                                  >
                                                    <SVG name="Chevron" width={10} height={10} />
                                                  </span>
                                                )}
                                              </a>
                                            </span>
                                          )}
                                        </li>
                                      ))}
                                  </ul>
                                ))}
                              </>
                            </div>
                          )}
                      </li>
                    ))}
                  </ul>
                  <div>
                    {WebSettings.headerLink1Text && (
                      <a
                        href={WebSettings.headerLink1URL}
                        className={classes.headerNavOtherLinksMobile}
                      >
                        {WebSettings.headerLink1Text}
                      </a>
                    )}
                    {WebSettings.headerLink2Text && (
                      <a
                        href={WebSettings.headerLink2URL}
                        className={classes.headerNavOtherLinksMobile}
                      >
                        {WebSettings.headerLink2Text}
                      </a>
                    )}
                  </div>
                </nav>
              </div>
            </div>
            <div className={classes.mobileLogin}>
              {WebSettings.headerButtonText && displayDiscountBtn && (
                <a
                  href={WebSettings.headerButtonURL}
                  className={classes.headerNavLinkBooking}
                  style={{ cursor: 'pointer' }}
                >
                  {WebSettings.headerButtonText}
                </a>
              )}
              {/* {WebSettings.headerButtonText && displayDiscountBtn && (
                <div
                  onClick={openFormPanel}
                  className={classes.headerNavLinkBooking}
                  style={{ cursor: 'pointer' }}
                >
                  {WebSettings.headerButtonText}
                </div>
              )} */}
            </div>
            <div className={classes.mobileTrigger} onClick={toggleMenu}>
              <div style={{ width: 30, textAlign: 'center' }}>
                {active ? (
                  <SVG name={'Cross'} width={18} height={18} colorOne={'#01396c'} />
                ) : (
                  <SVG name={'Menu'} width={30} height={18} colorOne={'#01396c'} />
                )}
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  )
}

Header.propTypes = {
  menuLinkManageText: PropTypes.string,
  menuLinkManageHref: PropTypes.string,

  menuLinkPhoneText: PropTypes.string,
  menuLinkPhoneAltText: PropTypes.string,
  menuLinkPhoneHref: PropTypes.string,

  menuLinkContactText: PropTypes.string,
  menuLinkContactHref: PropTypes.string,

  menuLinks: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string,
      text: PropTypes.string,
      class: PropTypes.node,
    }),
  ),
}

export default Header
